import moment from "moment";
import RED from './../assets/img/red.png'
import YELLOW from './../assets/img/yellow.png'
import GREEN from './../assets/img/green.png'
import ORANGE from './../assets/img/orange.png'
import PINK from './../assets/img/pink.png'
import GRAY from './../assets/img/gray.png'
import BLUE from './../assets/img/blue.png'
import PURPLE from './../assets/img/purple.png'

// Capitalize first letter
export function capitalizeUsername(username: string): string {
  if (!username) return "";

  return username
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

// date format (i.e May 24, 2025)
export function formatToLongDate(date: string | number | Date): string {
  return moment(date).format("MMMM D, YYYY");
}

export const formatToSlug = (text: string): string => {
  return text
    .toLowerCase()
    .trim()
    .replace(/[\s\/]+/g, "-") // replace spaces and slashes with dashes
    .replace(/[^a-z0-9-]/g, "") // remove all other special characters
    .replace(/-+/g, "-") // collapse multiple dashes
    .replace(/^-+|-+$/g, ""); // remove leading/trailing dashes
};

// export const splitName = (fullName: string) => {
//   const parts = fullName.trim().split(" ");
//   const firstName = parts[0]
//     ? parts[0].charAt(0).toUpperCase() + parts[0].slice(1).toLowerCase()
//     : "";

//   const lastName =
//     parts.length > 1 ? parts[1].charAt(0).toUpperCase() + "." : "";

//   return { firstName, lastName };
// };

export const splitName = (fullName: string) => {
  const parts = fullName.trim().split(" ");
  return {
    firstName: parts[0] || "",
    lastName: parts.length > 1 ? parts.slice(1).join(" ") : "",
  };
};




export const lanternData = [
  {
    id: 1,
    imgURL: RED,
    btnTxtColor: '#fff',
    btnBGColor: '#F74007',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Red'
  },
  {
    id: 2,
    imgURL: YELLOW,
    btnTxtColor: '#060606',
    btnBGColor: '#F7C100',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Yellow'
  },
  {
    id: 3,
    imgURL: GREEN,
    btnTxtColor: '#fff',
    btnBGColor: '#2F9E44',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Green'
  },
  {
    id: 4,
    imgURL: ORANGE,
    btnTxtColor: '#fff',
    btnBGColor: '#F76707',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Orange'
  },
  {
    id: 5,
    imgURL: PINK,
    btnTxtColor: '#fff',
    btnBGColor: '#FF6B9A',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Pink'
  },
  {
    id: 6,
    imgURL: GRAY,
    btnTxtColor: '#33363F',
    btnBGColor: '#F1F3F5',
    overlayTxtColor: '#000000',
    btnLabel: 'White'
  },
  {
    id: 7,
    imgURL: BLUE,
    btnTxtColor: '#fff',
    btnBGColor: '#228BE6',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Blue'
  },
  {
    id: 8,
    imgURL: PURPLE,
    btnTxtColor: '#fff',
    btnBGColor: '#9C36B5',
    overlayTxtColor: '#DCD300',
    btnLabel: 'Purple'
  },
]